<template>
  <div class="mymachines-consent-gdpr-modal">
    <div v-if="!myMachines.isGdprConsentGiven">
      <div class="mymachines-consent-container">
        <div
          class="mymachines-consent-form"
          :style="{ 'max-height': dynamicMaxHeight + 'px' }"
          @scroll="checkScroll"
          v-html="tStatic('machineConsentForm')">
        </div>
      </div>
      <oie-action-wrapper>
        <oie-base-action
          size="large"
          theme="skeleton"
          @click="closeModal">
          {{ tStatic('machineConsentDeny') }}
        </oie-base-action>
        <oie-base-action
          size="large"
          :disabled="!hasReadConsentForm"
          @click="confirmConsent">
          {{ tStatic('machineConsentConfirm') }}
        </oie-base-action>
      </oie-action-wrapper>
    </div>
    <div v-else>
      <div class="mymachines-consent-thankyou" v-html="tStatic('machineConsentThankYou')">
      </div>
      <oie-action-wrapper>
        <oie-base-action size="large" @click="closeModal">
          {{ tStatic('machineConsentContinue') }}
        </oie-base-action>
      </oie-action-wrapper>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dynamicMaxHeight: 0,
      isScrollComplete: false
    }
  },
  computed: {
    ...mapGetters('myMachines', ['myMachines']),
    hasReadConsentForm() {
      return this.isScrollComplete
    }
  },
  mounted() {
    this.dynamicMaxHeight = window.innerHeight * 0.7
  },
  methods: {
    ...mapActions('myMachines', ['setMyMachinesConsentGdpr', 'getMyMachines']),
    async confirmConsent() {
      if (!this.hasReadConsentForm) { return }
      await this.setMyMachinesConsentGdpr()
      this.options.confirmConsent()
    },
    closeModal() {
      this.options.declineConsent()
    },
    checkScroll() {
      const consentForm = document.querySelector('.mymachines-consent-form')
      if (consentForm) {
        if (consentForm.scrollHeight - consentForm.scrollTop - 1 < consentForm.clientHeight) {
          this.isScrollComplete = true
        }
      }
    }
  }
}
</script>

<style lang="scss">

.mymachines-consent-gdpr-modal {
  > h3 {
    @include h3-bold;
    margin: 0;
  }

  > p {
    margin: 1rem 0 1.5rem 0;
  }
}

.mymachines-consent-container {
  margin-top: measure(half);
  margin-bottom: measure(half);
}

.mymachines-consent-form {
  overflow-y: scroll;
}

.mymachines-consent-thankyou {
  margin-bottom: measure(half);
}

</style>
